@if (productPlan && accountingPlan) {

	<section *requiredCredential="startProductPlanManuallyAllowed; and: !accountingPlan.startUpDeliveryDate || !accountingPlan.startDate">
		<button #registerStartButton [active]="!accountingPlan.startDate" (click)="registerStartOfPlan()" [label]="(!accountingPlan.startDate ? 'company.accounting-plans.start-of-plan' : 'company.accounting-plans.plan-is-started') | translate" [ignoreValidation]="true"></button>
	</section>
	<panel-row>
		<section>
			<h3>{{ 'company.product-plans.current-accounting-plan' | translate }}</h3>
			<text-group>
				<div>{{ brand?.name }}</div>
				<div><icon [attr.brand]="brand?.shortName" type="logo" small /></div>
				<div>{{ 'company.accounting-plans.reference-no' | translate }}</div>
				<div>{{ accountingPlan.referenceNo }}</div>
				<div>{{ 'company.accounting-plans.overview-interval-months' | translate }}</div>
				<div>{{ (accountingPlan.startDate ? accountingPlan.paymentInterval : productPlan.paymentScheme) | paymentInterval:{ installments: accountingPlan.numberOfInstallments, accountingPlan: accountingPlan } }}</div>
				<div>{{ 'company.accounting-plans.overview-product-dimension-code' | translate }}</div>
				<div>{{ accountingPlan.accountingPlanSetup!.productDimensionCode }}</div>
				<div>{{ 'company.accounting-plans.max-counter-value' | translate }}</div>
				@if (maxCounterValue === undefined) { <div><skeleton /></div> }
				@else { <div>{{ maxCounterValue | currency }}</div> }
				<div>{{ 'company.product-plan.overview-temination-notice-period' | translate }}</div>
				<div>{{ productPlan.terminationNoticePeriod > 0 ? ('company.product-plan.termination-notice-period' | translate: {period: productPlan.terminationNoticePeriod}) : ('company.product-plan.no-termination-notice-period' | translate) }}</div>
			</text-group>
		</section>
		@if (!productPlan.autoRenewable) {
			<section></section>
		}
		@else {
			@if (!productPlan.terminationDate) {
				<section>
					<menu>
						<menuitem *requiredCredential="editAccountingCredential; and: accountingPlan.suspended == undefined" (click)="editAutoRenewal()">{{ 'company.product-plans.auto-renewal.edit' | translate }}</menuitem>
					</menu>
					<h3>{{ 'company.accounting-plans.auto-renewal' | translate }}</h3>
					<text-group>
						<div>{{ 'company.product-plans.auto-renewal.date-for-renewal' | translate }}</div>
						<div>{{ productPlan.autoRenewalDate | customDate: 'shortDate' }}</div>
						<div>{{ 'company.product-plans.auto-renewal.yearly-value' | translate }}</div>
						<div>{{ productPlan.annualValueForRenewal | currency }}</div>
						<div>{{ 'company.product-plans.auto-renewal.month-count' | translate }}</div>
						<div>{{ productPlan.nextPeriod }}</div>
						<div>{{ 'company.product-plans.auto-renewal.payment-interval' | translate }}</div>
						<div>{{ (accountingPlan.startDate ? accountingPlan.paymentInterval : productPlan.paymentScheme) | paymentInterval:{ installments: !!accountingPlan.numberOfInstallments ? 1 : undefined, accountingPlan: accountingPlan } }}</div>
					</text-group>
				</section>
			}
			@else {
				<section alert>
					<h3>{{ 'company.product-plans.terminated' | translate }}</h3>
					<text-group>
						<div>{{ 'company.product-plans.termination-date' | translate }}</div>
						<div>{{ productPlan.terminationDate | customDate: 'shortDate' }}</div>
						<div>{{ 'company.product-plans.endDate' | translate }}</div>
						<div>{{ productPlan.autoRenewalDate | customDate: 'shortDate' }}</div>
						<div>{{ 'company.product-plans.terminated-reason' | translate }}</div>
						@if (terminationReason) { <div>{{ terminationReason.name }}</div> }
						@else { <div>{{ noTerminationReasonLabel ? (noTerminationReasonLabel | translate) : '' }}</div> }
						<div>{{ 'company.product-plans.auto-renewal.yearly-value' | translate }}</div>
						<div>{{ productPlan.annualValueForRenewal | currency }}</div>
					</text-group>
				</section>
			}
		}
	</panel-row>
	@if (accountingPlan.startDate && productPlan.autoRenewable) {
		<section *requiredCredential="editAccountingCredential">
			@if (!productPlan.terminationDate) {
				<button confirm [loader]="false" [ignoreValidation]="true" [active]="accountingPlan.suspended == undefined" (click)="initiateTerminate()">
					<icon type="door-open" />{{ 'company.accounting-plans.terminate' | translate }}
				</button>
			}
			@if (allowUndoTerminate()) {
				<button reject [loader]="false" [ignoreValidation]="true" [active]="accountingPlan.suspended == undefined" (click)="undoTerminate()">
					<icon type="door-closed" />{{ 'company.accounting-plans.undo-terminate' | translate }}
				</button>
			}
		</section>
	}
}
